/**
 * Store: Main Collection
 * -----------------------------------------------------------------------------
 * Main collection state and events.
 * - Only JSDOC custom parameters, ignore module state or object.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    choices: '',
    filter: {},
  }),

  getters: {

    /**
     * Gets user choices.
     * @returns {String}
     */
    getChoices(state) {
      return state.choices
    },

    /**
     * Gets available filters.
     * @returns {Object}
     */
    getFilters(state) {
      return state.filter
    },
  },

  mutations: {

    /**
     * Updates choices state.
     * @param {String} choices - User choices.
     */
    updateChoices(state, choices) {
      state.choices = choices
    },

    /**
     * Updates filters state.
     * @param {Object} filter - Filters response from Boost.
     */
    updateFilters(state, filter) {
      state.filter = filter
    },
  },

  actions: {

    /**
     * Actions choices update.
     * @param {String} choices - User choices.
     */
    updateChoices({ commit }, choices) {
      commit('updateChoices', choices)
    },

    /**
     * Actions filters update.
     * @param {Object} filter - Filters response from Boost.
     */
    updateFilters({ commit }, filter) {
      commit('updateFilters', filter)
    },
  },
}
